import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Fade, useMediaQuery, useTheme } from '@material-ui/core';
import { useAppContext } from 'contexts/AppContext';
import defaultLocales from 'globals/locales/default';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import FsPagination from 'ui-elements/tabs/FsPagination';
import FsButton from 'ui-elements/buttons/FsButton';
import FsLeaderboardTable from 'ui-elements/tables/FsLeaderboardTable';
import FsAddNewUserModal from 'ui-elements/modals/FsAddNewUserModal';
import FsMinWidthScrollBox from 'ui-elements/boxes/FsMinWidthScrollBox';
import { PaginationWrapperBox } from './Leaderboard.style-elements';
import { dummyPagination, headLabelsLongVersion } from './Leaderboard.utils';

const Leaderboard: React.FC = () => {
  const {
    leaderboardList: { getLeaderboardListItems, init: initStore },
  } = useAppContext();
  const [showModal, setShowModal] = useState<boolean>(false);
  const theme = useTheme();
  const isUpSm = useMediaQuery(theme.breakpoints.up('sm'), {
    noSsr: true,
  });

  useEffect(() => {
    initStore();
  }, [initStore]);

  const buttons = [
    <FsButton
      variant="contained"
      color="primary"
      key={1}
      onClick={() => setShowModal(true)}
    >
      {isUpSm ? defaultLocales.inviteNewTeammate : defaultLocales.invite}
    </FsButton>,
  ];

  return (
    <Fade in timeout={1000}>
      <FsPaper
        data-test="leaderboard-page"
        title={defaultLocales.manageYourTeam}
        buttons={buttons}
      >
        <FsMinWidthScrollBox breakpointDown="md" minWidth={600}>
          <FsLeaderboardTable
            rows={getLeaderboardListItems()}
            headLabels={headLabelsLongVersion}
            isLongVersion
          />
        </FsMinWidthScrollBox>
        <FsMinWidthScrollBox minWidth={290}>
          <PaginationWrapperBox>
            <FsPagination paginationInfo={dummyPagination} />
          </PaginationWrapperBox>
        </FsMinWidthScrollBox>
        {showModal && <FsAddNewUserModal onClose={() => setShowModal(false)} />}
      </FsPaper>
    </Fade>
  );
};

export default observer(Leaderboard);
